import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Folder } from 'src/app/digigov/models/folder.model';
import { Observable } from 'rxjs';

//import { User } from '@/_models';

@Injectable({ providedIn: 'root' })
export class FolderService {
  constructor(private http: HttpClient) { }

  getALl(): Observable<any> {
    return this.http.get('/case-mgmnt/user-folders');
    //return this.http.get(this.url+'/case-mgmnt/user-folders')
  }

  addFolder(folder: Folder) {
    return this.http.post<Folder>('/case-mgmnt/folder', folder);
  }

  editFolder(folder: Folder) {
    return this.http.put<Folder>('/case-mgmnt/folder', folder);
  }

  deleteFolder(folder: Folder[]) {
    return this.http.put<Folder[]>('/case-mgmnt/folder/remove', folder);
  }
}
